import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M12 10.667L16.667 6 18 7.333 13.333 12 18 16.667 16.667 18 12 13.333 7.333 18 6 16.667 10.667 12 6 7.333 7.333 6 12 10.667z"
      ></path>
    </svg>
  )
}

export default Icon
